export const translate = {
	en: {
		groupPlanText: "Group Plan",
		healthPlanText: "Health Plan",
		addDependentButtonText: "Add Dependent",
		premiumText: "Premium",
		totalPremiumText: "Total Premium",
		signinText: "Please sign below",
		herebyText: "I hereby",
		firstCheckBoxContent: "ARE YOU OR YOUR DEPENDENTS COVERED UNDER ANOTHER GROUP INSURANCE POLICY",
		requestToEnrollText: "Request to enroll in that",
		benefitClickPlanText: "BENEFIT PLAN",
		aSummaryForRequestText: "for which I am or may become eligible under the Plan created by the above",
		planSCoreClickText: "PLAN SPONSOR",
		reafirmText: "Reafirm that I will abide by the provisions set forth in the",
		summaryPlanClickText: "SUMMARY PLAN DESCRIPTION",
		andText: "and",
		planDocumentClickText: "PLAN DOCUMENT",
		authorizeTheText: "Authorize the required deductions, if any, from my earnings",
		certifyText: "Certify that the above dates of birth and other information are correct",
		iUnderstandText:
			"I understand that cannot change or drop coverage prior to next open enrollment period unless a change of family and/or job status occur.",
		secondCheckBoxContent:
			"I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE THE PAYROLL DEDUCTIONS TO BE MADE AS INDICATED",
		signature: "Signature",
		date: "Date",
		chooseText: "Choose your desired plan",
		coverageEmployeeOnlyText: "Employee Only",
		coverageForSpouseText: "Coverage For Spouse",
		coverageChildText: "Coverage For Child(ren)",
		coverageForFamily: "Coverage For Family"
	},
	es: {
		groupPlanText: "Plan de grupo",
		healthPlanText: "Plan de salud",
		premiumText: "De primera calidad",
		totalPremiumText: "Prima Total",
		signinText: "Por favor firme abajo",
		herebyText: "por la presente",
		addDependentButtonText: "Agregar dependiente",
		firstCheckBoxContent: "USTED O SUS DEPENDIENTES ESTÁN CUBIERTOS POR OTRA PÓLIZA DE SEGURO GRUPAL",
		requestToEnrollText: "Solicitud de inscripción en ese",
		benefitClickPlanText: "PLAN DE BENEFICIOS",
		aSummaryForRequestText: "para el cual soy o puedo llegar a ser elegible según el Plan creado por lo anterior",
		planSCoreClickText: "PATROCINADOR DEL PLAN",
		reafirmText: "Reafirmo que acataré las disposiciones establecidas en el",
		summaryPlanClickText: "DESCRIPCIÓN RESUMEN DEL PLAN",
		andText: "y",
		planDocumentClickText: "DOCUMENTO DEL PLAN",
		authorizeTheText: "Autorizar las deducciones requeridas, si las hubiera, de mis ganancias",
		certifyText: "Certificar que las fechas de nacimiento anteriores y otra información son correctas",
		iUnderstandText:
			"Entiendo que no puedo cambiar ni cancelar la cobertura antes de la próxima inscripción abiert período a menos que ocurra un cambio de situación familiar y/o laboral.",
		secondCheckBoxContent:
			"ENTIENDO Y ACEPTO LOS TÉRMINOS Y CONDICIONES MENCIONADOS ANTERIORMENTE Y AUTORIZO EL DEDUCCIONES DE NÓMINA QUE SE REALIZARÁN COMO SE INDICA",
		signature: "Firma",
		date: "Fecha",
		chooseText: "Elige tu plan deseado",
		coverageEmployeeOnlyText: "Sólo empleado",
		coverageForSpouseText: "Cobertura para el cónyuge",
		coverageChildText: "Cobertura para niños",
		coverageForFamily: "Coverage For Family"
	}
};
